<template>
  <div id="main-layout" v-on:click="evtCloseMenu">
    <header>
      <nav class="header-base navbar navbar-expand-md">
        <div id="logo-base">
          <router-link to="/">
            <img
              src="https://bucket-tarserp-resources.s3-sa-east-1.amazonaws.com/images/onelogo-base.png"
            />
          </router-link>
        </div>
        <button
          class="navbar-toggler collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#navbarCollapse"
          aria-controls="navbarCollapse"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="fas fa-bars"></i>
        </button>
        <div id="navbarCollapse" class="navbar-collapse collapse nav-container">
          <div id="start">
            <router-link to="/signup/business/welcome">INICIAR AGORA</router-link>
          </div>
          <div id="nav" class="row">
            <button
              class="col-12 col-lg-2"
              v-on:click="evtShowMenu('resources')"
              v-bind:class="{ active: showMenu == 'resources' }"
            >
              RECURSOS
              <i class="fas fa-angle-down"></i>
            </button>

            <!-- <router-link 
              class="col-12 col-lg-2" 
              to="support"
              tag="button"
            >
              Suporte
            </router-link>-->

            <router-link class="col-12 col-lg-2" to="pricing" tag="button">PLANOS</router-link>

            <!-- <router-link to="/security/" class="col-12 col-lg-2" tag="button">Segurança</router-link> -->
            <!-- <button class="col-12 col-lg-2">Guia</button>             -->
          </div>
        </div>
      </nav>

      <div id="over-menu" v-if="showMenu != ''">
        <div id="menu-place">
          <div id="resources" v-if="showMenu == 'resources'" class="row">
            <div class="resource-group col-12 col-lg-4">
              <a href="#" target="_blank">
                <img class="task-image"
                  src="https://bucket-tarserp-resources.s3-sa-east-1.amazonaws.com/images/task-base.png"
                />

                <p>
                  O Task é o sistema de gestão de processos e tarefas baseado em nuvem
                  que atende a todas as equipes de qualquer empresa.
                </p>

                <p>
                  Automatize fluxos, gerencie quadros de Kanban, tenha relatórios de produtividade,
                  rastreie horas de trabalho e conecte-se com seus clientes. 
                </p>
              </a>
            </div>

            <div class="resource-group col-12 col-lg-4">
              <img class="react-image"
                  src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-react-color.webp"
                />

              <p>
                Crie formulários e envie para seus clientes, funcionários. Crie pesquisas, 
                relatórios de qualidade ou o que você quiser!
              </p>

              <p>
                Receba as respostas dos formulários em por e-mail. As respostas podem ser 
                transformadas em tarefas no <b>Task</b> de forma automática.
              </p>
            </div>

            <div class="resource-group col-12 col-lg-4">
              <img class="echo-image"
                src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-echo.webp"/>

              <p>
                Comunique-se com sua equipe em conversas individuais e de grupo.                            
              </p>

              <p>
                Converse com seu cliente por meio da integração ao <b>Whatsapp</b> e mantenha todas 
                suas conversas num só lugar.
              </p>
            </div>

            <div class="resource-group col-12 col-lg-4">
              <img class="analyser-image"
                src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-analyser.webp"/>

              <p>Por meio de Inteligência Artificial, crie contratos, faça a validação de documentos.</p>
              <p>Faça a validação de documentos em lote e faça em segundos o que normalmente leva horas!</p>
            </div>

            <div class="resource-group col-12 col-lg-4">
              <img class="adminconsole-image"
                src="https://bucket-tarserp-resources.s3.sa-east-1.amazonaws.com/images/logo-oneadmin.webp"/>

              <p>Gerencie todos os seus usuários e como eles utilizam os serviços do One.</p>
              
            </div>
          </div>

          <div id="side-menu">
            <div id="right-button">
              <a v-on:click="showMenu = ''">
                <i class="fas fa-times"></i>
              </a>
            </div>

            <!-- <div>
              
              <p><b> Fale conosco </b></p>
              <a>
                <i class="fab fa-whatsapp"></i>
              </a>

            </div>-->
          </div>
        </div>
      </div>
    </header>

    <slot />

    <footer>
      <div class="footer-wrapper">
        <div id="footer-top" class="row">
          <div class="footer-block col-12 col-lg-2">
            <a>
              <img
                src="https://bucket-tarserp-resources.s3-sa-east-1.amazonaws.com/images/onelogo-full-white.png"
              />
            </a>
          </div>

          <div class="footer-block col-6 col-lg-2">
            <h4>RECURSOS</h4>

            <div class="footer-options">
              <a href="https://task.tars.com.br" target="_blank">Task</a>
              <a href="https://echo.tars.com.br" target="_blank">Echo</a>
              <a href="https://react.tars.com.br" target="_blank">React</a>
              <a href="https://analyser.tars.com.br" target="_blank">Analyser</a>
            </div>
          </div>
          <!-- 
          <div class="footer-block col-6 col-lg-2">
            <h4>PREÇOS</h4>

            <div class="footer-options">
              <router-link to="pricing">Consulte a tela de preços</router-link>
            </div>
          </div>-->

          <div class="footer-block col-6 col-lg-2">
            <h4>SUPORTE</h4>

            <div class="footer-options">
              <!-- <a>Ajuda</a> -->
              <a href="https://tars.com.br/#footer" 
                target="_blank">Contato</a>
              <!-- <a>Abrir um chamado</a> -->
            </div>
          </div>

          <!-- <div class="footer-block col-6 col-lg-2">
            <h4>APRENDA</h4>

            <div class="footer-options">
              <a>Vídeos</a>
              <a>Guia de implantação</a>
            </div>
          </div>-->

          <div class="footer-block col-6 col-lg-2">
            <h4>SOBRE A TARS</h4>

            <div class="footer-options">
              <a href="https://tars.com.br" target="_blank">Empresa</a>
              <!-- <a>Carreiras</a> -->
              <!-- <a>Produtos</a> -->
              <!-- <a>Blog</a> -->
            </div>
          </div>

          <div id="footer-block-tars" class="col-12 col-lg-4">
            <a href="https://www.facebook.com/tecnologiatars" target="_blank">
              <i class="fab fa-facebook-square"></i>
            </a>
            <a href="https://www.instagram.com/tarstecnologia" target="_blank">
              <i class="fab fa-instagram-square"></i>
            </a>
            <a href="https://www.linkedin.com/company/tars-tecnologia" target="_blank">
              <i class="fab fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>

      <div id="footer-middle"></div>

      <div class="footer-wrapper">
        <div id="footer-bottom" class="row">
          <div id="footer-block-terms" class="row col-12 col-lg-7">
            <a>® {{new Date().getFullYear()}} TARS One. Todos os direitos reservados.</a>
            <router-link to="/policies/privacy">Política de privacidade</router-link>
            <router-link to="/policies/terms">Termos de uso</router-link>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "main-layout",
  data: function() {
    return {
      showMenu: ""
    };
  },
  methods: {
    evtShowMenu(option) {
      if (option != this.showMenu) this.showMenu = option;
      else this.evtCloseMenu();
    },
    evtCloseMenu(e) {
      if (e == undefined) {
        this.showMenu = "";
        return;
      }

      var container = $("header");

      if (
        container.length &&
        !container.is(e.target) &&
        container.has(e.target).length === 0
      ) {
        this.showMenu = "";
      }
    }
  }
};
</script>

<style lang="scss">
@import "./node_modules/include-media/dist/_include-media.scss";

$breakpoints: (
  phone: 640px,
  tablet: 768px,
  desktop: 1024px
) !default;

#main-layout {
  display: flex;
  flex-direction: column;
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  min-height: 100vh;

  header {
    position: relative;
    border-bottom: 1px solid #000;

    .header-base {
      padding-bottom: 0px;
      padding-top: 0px;

      display: flex;
      justify-content: space-around;
      max-width: 1300px;
      margin: 0 auto;

      #logo-base {
        flex: 1;
        text-align: left;

        a img {
          width: 80px;

          @include media(">phone", "<tablet") {
            width: 60px;
          }

          @include media(">tablet", "<950px") {
            width: 60px;
          }
        }
      }

      .navbar-toggler {
        border: 1px solid #999;
        border-radius: 5px;
        outline: none;

        i {
          color: #999;
        }
      }

      .nav-container {
        @include media(">950px") {
          flex: 4;
          display: flex;
          flex-direction: row-reverse;
        }

        #nav {
          @include media(">950px") {
            flex: 3;
          }

          padding: 0;
          text-align: center;

          @include media(">phone", "<tablet") {
            margin: 0px;
          }

          @include media(">tablet", "<950px") {
            margin: 0px;
          }

          button {
            white-space: nowrap;
            font-weight: 600;
            color: #2c3e50;
            padding-top: 5px;
            padding-bottom: 5px;
            border-radius: 3px;
            cursor: pointer;
            background-color: transparent;
            border: none;
            margin-right: 10px;
            margin-top: 5px;
            outline: none;
            transition: background-color 0.2s;

            @include media(">phone", "<tablet") {
              text-align: left;
            }

            @include media(">tablet", "<950px") {
              text-align: left;
            }
          }

          button:hover {
            color: #108f65;
            background-color: #eee;
          }

          .active {
            color: #108f65;
            background-color: #eee;
          }
        }

        #start {
          @include media(">950px") {
            flex: 1;
          }
          font-weight: 600;
          padding: 25px 0;
          text-align: right;

          @include media(">phone", "<tablet") {
            font-size: 1rem;
            padding: 20px 0 10px 0;
            text-align: left;
          }

          @include media(">tablet", "<950px") {
            font-size: 1rem;
          }

          a {
            // background-color: #25b686;
            color: #000;
            padding: 10px 30px;
            text-decoration: none;
            border-radius: 3px;
            transition: background-color 0.2s;
          }

          a:hover {
            color: #108f65;
            background-color: #eee;
            // background-color: #108f65;
          }
        }
      }
    }

    #over-menu {
      position: absolute;
      top: -1;
      width: 100%;
      border-top: 1px solid #292929;
      background-color: #fff;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
      z-index: 100;

      #menu-place {
        display: flex;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;

        #resources {
          flex: 4;
          width: 90%;
          margin: 0 auto;
          display: flex;

          .resource-group {
            width: 30%;
            font-size: 14px;
            font-weight: 300;

            img {
              margin: 25px 0;
            }

            img.task-image {
              width: 80px;
            }

            img.react-image {
              width: 85px;
            }

            img.echo-image {
              width: 65px;
            }

            img.analyser-image {
              width: 150px;
            }

            img.adminconsole-image {
              width: 200px;
            }

            h4 {
              margin-top: 20px;
              margin-bottom: 0;
            }

            a {
              text-decoration: none;
              color: inherit;
            }
          }

          #resource-task {
            img {
              margin-top: 20px;
              margin-bottom: 6px;
              width: 90px;
            }
          }

          #resource-target {
            img {
              margin-top: 25px;
              width: 90px;
            }
          }
        }

        #side-menu {
          position: absolute;
          top: 5px;
          right: 10px;

          #right-button {
            text-align: right;

            a {
              cursor: pointer;
              font-size: 20px;
            }

            a:hover {
              color: #25b686;
            }
          }
        }
      }
    }
  }

  footer {
    width: 100%;
    margin-top: auto;
    background-color: #000000;
    border-top: 1px solid #999;
    color: #fff;

    .footer-wrapper {
      max-width: 1200px;
      margin: 0 auto;

      #footer-top {
        margin: 0px auto 30px auto;

        .footer-block {
          margin-top: 25px;

          img {
            width: 150px;
            cursor: pointer;
          }

          h4 {
            font-size: 16px;

            @include media(">phone", "<tablet") {
              font-size: 16px;
            }

            @include media(">tablet", "<950px") {
              font-size: 16px;
            }
          }

          .footer-options {
            display: flex;
            flex-direction: column;

            a {
              flex: 1;
              cursor: pointer;
              line-height: 22px;
              transition: color 0.2s;
              font-size: 14px;
              font-weight: 300;
              color: inherit;

              @include media(">phone", "<tablet") {
                font-size: 12px;
              }

              @include media(">tablet", "<950px") {
                font-size: 16px;
              }
            }

            a:hover {
              color: #ddd;
              text-decoration: none;
            }
          }
        }
      }

      #footer-block-tars {
        text-align: right;
        margin-top: 25px;

        @include media(">phone", "<tablet") {
          margin-top: 10px;
        }

        @include media(">tablet", "<950px") {
          margin-top: 10px;
        }

        a {
          cursor: pointer;

          i {
            color: #adb5bd;
            font-size: 30px;
            margin-left: 10px;
          }
        }

        img {
          width: 100px;
          cursor: pointer;
        }
      }
      #footer-bottom {
        // margin-right: 0;
        padding: 10px 0px;

        #footer-block-terms {
          margin: auto;
          margin-right: 0;
          a,
          router-link {
            margin: auto;
            margin-right: 0;
            // margin-left: 0;
            padding-left: 20px;
            color: #fff;
            text-decoration: none;
            line-height: 30px;
            // padding: 0 10px;
            transition: color 0.2s;
            line-height: 30px;
            font-size: 12px;
            text-align: right;
          }

          a:hover {
            color: #ddd;
          }
        }
      }
    }

    #footer-middle {
      border-top: 1px solid #000;
    }
  }
}

.center {
  text-align: center;
}
</style>
